module.exports = __webpack_public_path__ + "static/media/W05F0004N0000.1dddb094.svg";